import {createContext} from 'react'

export const CustomerReportContext = createContext({
  customerGroupData: [] as any,
  isCustomerGroupLoading: false,
  customerGroupFilters: {},
  onCustomerGroupSortingChange: (key: string, order: string) => {},
  onCustomerGroupDateChange: (startDate: any, endDate: any) => {},
  onChangeCustomerGroupFilter: (values: any[]) => {},

  customerTypeData: [],
  isCustomerTypeLoading: false,
  customerTypeFilters: {},
  onCustomerTypeSortingChange: (key: string, order: string) => {},
  onCustomerTypeDateChange: (startDate: any, endDate: any) => {},

  customerGroups: [] as any[],
  isCustomerGroupsLoading: false,

  entityPerformanceChartData: [] as any,
  isEntityPerformanceChartDataLoading: false,
  onEntityPerformanceChartIdChange: (id: string) => {},
  onEntityPerformanceChartViewChange: (e: any) => {},
  onEntityPerformanceChartDateRangeChange: (startDate: any, endDate: any) => {},
  entityPerformanceChartFilters: {} as any,

  customerTypeEntityPerformanceChartData: [] as any,
  isCustomerTypeEntityPerformanceChartDataLoading: false,
  onCustomerTypeEntityPerformanceChartIdChange: (id: string) => {},
  onCustomerTypeEntityPerformanceChartViewChange: (e: any) => {},
  onCustomerTypeEntityPerformanceChartDateRangeChange: (startDate: any, endDate: any) => {},
  customerTypeEntityPerformanceChartFilters: {} as any,
})

export const SalesRepReportContext = createContext({
  salesRepData: [],
  isSalesRepLoading: false,
  filters: {},
  onSalesRepSearch: (value: string) => {},
  onSalesRepSortingChange: (key: string, order: string) => {},
  onDateChange: (startDate: any, endDate: any) => {},
  onChangeSalesRepTypeFilter: (values: any[]) => {},

  salesRepTypes: [],
  isSalesRepTypeDropdownLoading: false,

  entityPerformanceChartData: [] as any,
  isEntityPerformanceChartDataLoading: false,
  onEntityPerformanceChartIdChange: (id: string) => {},
  onEntityPerformanceChartViewChange: (e: any) => {},
  onEntityPerformanceChartDateRangeChange: (startDate: any, endDate: any) => {},
  entityPerformanceChartFilters: {} as any,
})

export const SalesRepTypeReportContext = createContext({
  salesRepTypeData: [],
  isSalesRepTypeLoading: false,
  filters: {},
  onSortingChange: (key: string, order: string) => {},
  onDateChange: (startDate: any, endDate: any) => {},

  entityPerformanceChartData: [] as any,
  isEntityPerformanceChartDataLoading: false,
  onEntityPerformanceChartIdChange: (id: string) => {},
  onEntityPerformanceChartViewChange: (e: any) => {},
  onEntityPerformanceChartDateRangeChange: (startDate: any, endDate: any) => {},
  entityPerformanceChartFilters: {} as any,
})
